import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import MaintenanceGate from "@/components/MaintenanceGate";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import RulesPage from "@/pages/RulesPage";
import ForumHomePage from "@/pages/ForumHomePage";
import ForumCategoryPage from "@/pages/ForumCategoryPage";
import ForumTopicPage from "@/pages/ForumTopicPage";
import NewTopicPage from "@/pages/NewTopicPage";
import BoutiquePage from "@/pages/BoutiquePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import AdminPage from "@/pages/AdminPage";
import SanctionsPage from "@/pages/SanctionsPage";
import TicketsPage from "@/pages/TicketsPage";
import NewTicketPage from "@/pages/NewTicketPage";
import TicketDetailPage from "@/pages/TicketDetailPage";
import NotFoundPage from "@/pages/NotFoundPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route element={<MaintenanceGate><Outlet /></MaintenanceGate>}>
            <Route path="/" element={<HomePage />} />
            <Route path="/reglement" element={<RulesPage />} />
            <Route path="/forum" element={<ForumHomePage />} />
            <Route path="/forum/c/:slug" element={<ForumCategoryPage />} />
            <Route path="/forum/c/:slug/nouveau" element={<NewTopicPage />} />
            <Route path="/forum/t/:id" element={<ForumTopicPage />} />
            <Route path="/boutique" element={<BoutiquePage />} />
            <Route path="/boutique/succes" element={<PaymentSuccessPage />} />
            <Route path="/boutique/annule" element={<PaymentCancelPage />} />
            <Route path="/sanctions" element={<SanctionsPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/tickets/nouveau" element={<NewTicketPage />} />
            <Route path="/tickets/:id" element={<TicketDetailPage />} />
            </Route>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
